import { Button, Col, Row } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .ant-typography {
    color: ${"#434343"};
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 4px;
  }

  .ant-tag {
    width: fit-content;
    color: ${"#595959"};
    font-weight: 500;
  }
`;

export const ContentWrapper = styled(Row)`
  .info-block {
    width: 344px;
    padding: 16px 32px 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .content-info-header {
      max-height: 16px;

      .ant-tag {
        color: ${"#1677ff"};
        font-weight: 500;
        line-height: 20px;
      }

      .project-name {
        color: ${"#595959"};
        font-weight: 600;
        font-size: 10px;
        line-height: 16px;
        text-transform: uppercase;
      }
    }
  }

  .chat-block {
    display: flex;
    flex-direction: column;
    width: 336px;
    min-height: 332px;
    padding: 12px;
    padding-top: 0;
    border-radius: 0px 0px 16px 16px;
    background-color: ${"#fafafa"};

    .chat-history {
      height: calc(100% - 28px);
      padding: 12px 0 16px;

      .message-element .message-main-block {
        max-width: calc(100% - 48px);
        padding: 12px !important;
        border-radius: 8px;
        background-color: white;
    

        .message-header > .ant-col:first-child {
          max-width: 208px;
        }
      }
    }

    .send-icon-wrapper {
      height: 32px;
      cursor: pointer;
    }
  }
`;

export const CommentModalActions = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;

  $.button {
    height: 24px;
    padding: 0;
    font-weight: 500;

    > span:last-child {
      height: 20px;
    }

    &.ant-btn.ant-btn-link.gray-button {
      color: ${"#bfbfbf"};
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export const MessagesWrapper = styled.div`
  flex: 1;
`;

export const BodyElementsWrapper = styled(Col)`
  > .ant-row:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const CommentModalBodyElementWrapper = styled(Row)`
  .ant-typography {
    font-weight: 500;
  }

  > .ant-col:first-child {
    width: 98px;

    > .ant-typography {
      color: ${"#8c8c8c"};
    }
  }

  > .ant-col:last-child {
    max-width: calc(100% - 98px);

    > .ant-typography {
      color: ${"#595959"};
    }
  }

  .scrollable-wrapper.withScroll .anticon.arrow-up {
    top: -12px;
  }
`;

export const GlobalModalStyles = createGlobalStyle`
  .ant-modal.comment-modal {
    max-height: calc(100vh - 80px);

    .ant-modal-close-x {
      width: 40px;
    }

    .ant-modal-header {
      padding-bottom: 16px;
      margin-right: 16px;
    }

    .ant-modal-body {
      padding: 0 16px 16px 24px;
    }
  }
`;
